import React, { Component } from 'react';

var config = process.env;

class PymoSettingsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isSubmitting: false,
            branches: [],
            selectedBranchId: '',
            url: '',
            rut: '',
            email: '',
            password: '',
            bo: '',
            showPassword: false,
        };
    }

    renderSensitiveInput = ({ label, value, onChange, isVisible, onToggle }) => (
        <div className="form-group mb-0">
            <label>{label}</label>
            <div className="input-group">
                <input
                    type={isVisible ? 'text' : 'password'}
                    className="form-control"
                    value={value}
                    onChange={onChange}
                    autoComplete="off"
                />
                <div className="input-group-append">
                    <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center"
                        onClick={onToggle}
                        aria-label={isVisible ? `Ocultar ${label}` : `Mostrar ${label}`}
                    >
                        <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                            {isVisible ? 'visibility_off' : 'visibility'}
                        </i>
                    </button>
                </div>
            </div>
        </div>
    )

    componentDidMount() {
        this.loadBranchesAndSettings();
    }

    loadBranchesAndSettings = async () => {
        this.setState({ loading: true });

        try {
            const branchesResponse = await fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch`, {
                method: 'GET',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
            });

            const branchesData = await branchesResponse.json();
            if (branchesData.error > 0) {
                alert(branchesData.message);
                return;
            }

            const branches = branchesData.data || [];
            const selectedBranchId = this.state.selectedBranchId || (branches[0] ? String(branches[0].id) : '');

            this.setState({ branches, selectedBranchId }, () => {
                this.loadSettings(selectedBranchId);
            });
        } catch (error) {
            this.setState({ loading: false });
        }
    }

    loadSettings = async (branchId) => {
        this.setState({ loading: true });

        try {
            const response = await fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}configuration/settings/pymo?branchId=${branchId}`, {
                method: 'GET',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();

            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.setState({
                selectedBranchId: String(branchId),
                url: data.data?.url || '',
                rut: data.data?.rut || '',
                email: data.data?.email || '',
                password: data.data?.password || '',
                bo: data.data?.bo || '',
                loading: false,
            });
        } catch (error) {
            this.setState({ loading: false });
        }
    }

    onBranchChange = (branchId) => {
        this.loadSettings(branchId);
    }

    onSubmit = async () => {
        this.setState({ isSubmitting: true });

        try {
            const response = await fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}configuration/settings/pymo`, {
                method: 'PUT',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    branchId: Number(this.state.selectedBranchId || 1),
                    url: this.state.url,
                    rut: this.state.rut,
                    email: this.state.email,
                    password: this.state.password,
                    bo: this.state.bo,
                }),
            });
            const data = await response.json();

            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.setState({
                url: data.data?.url || this.state.url,
                rut: data.data?.rut || this.state.rut,
                email: data.data?.email || this.state.email,
                password: data.data?.password || this.state.password,
                bo: data.data?.bo || this.state.bo,
            });
        } finally {
            this.setState({ isSubmitting: false });
        }
    }

    render() {
        return (
            <div className="card">
                <div className="d-flex justify-content-between align-items-center border-bottom" style={{ padding: '1rem 1.5rem' }}>
                    <span className="text-muted" style={{ fontSize: '0.95rem' }}>
                        Configurá PYMO por sucursal. La URL es global y el resto de las credenciales se guardan por branch.
                    </span>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.loadSettings(this.state.selectedBranchId)}>
                        Recargar
                    </button>
                </div>
                <div className="card-body">
                    {this.state.loading ? (
                        <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>Sucursal</label>
                                    <select
                                        className="custom-select"
                                        value={this.state.selectedBranchId}
                                        onChange={(event) => this.onBranchChange(event.target.value)}
                                    >
                                        {this.state.branches.map((branch) => (
                                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>URL base</label>
                                    <input className="form-control" value={this.state.url} onChange={(event) => this.setState({ url: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>RUT</label>
                                    <input className="form-control" value={this.state.rut} onChange={(event) => this.setState({ rut: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>BO</label>
                                    <input className="form-control" value={this.state.bo} onChange={(event) => this.setState({ bo: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input className="form-control" value={this.state.email} onChange={(event) => this.setState({ email: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                {this.renderSensitiveInput({
                                    label: 'Password',
                                    value: this.state.password,
                                    onChange: (event) => this.setState({ password: event.target.value }),
                                    isVisible: this.state.showPassword,
                                    onToggle: () => this.setState((prevState) => ({ showPassword: !prevState.showPassword })),
                                })}
                            </div>
                            <div className="col-12 mt-4">
                                <button className="btn btn-primary" onClick={this.onSubmit} disabled={this.state.isSubmitting}>
                                    Guardar configuración
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default PymoSettingsComponent;
